export enum OrderEntryIssueTypeInternational {
    EDI_ORDERING_ISSUE_INT = 'EDI Ordering Issue',
    MISSING_ITEMS_LINES_INT = 'Order Entry - Missing Items/Lines',
    WRONG_MATERIAL_INT = 'Order Entry - Wrong Material or Quantity',
    MISINFORMATION_PROVIDED_COMMUNICATION_INADEQUATE_INT = 'Misinformation Provided/Communication Inadequate',
    OTHER_INT = 'Other',
    WRONG_ACCOUNT_INT = 'Order Entry - Wrong Account'
}
